'use strict';

var getScrollY = require('../utils/getScrollY'),
    Animation = require('additive-animation');

var SmoothScrollMixin = {
  componentWillMount: function () {
    this._animation = new Animation({
      onRender: state => { window.scrollTo(0, state.y); }
    });
  },

  componentWillUnmount: function() {
    this._animation.cancel();
    this._animation = null;
  },

  isAnimatingScroll: function() {
    return this._animation.isAnimating();
  },

  stopAnimatingScroll: function() {
    this._animation.cancel();
  },

  animateScroll: function(targetY, duration) {
    this._animation.animate({ y: getScrollY() }, { y: targetY }, duration);
  }
};

module.exports = SmoothScrollMixin;


/** WEBPACK FOOTER **
 ** ./mixins/SmoothScrollMixin.js
 **/